// AlignUI · иллюстрация пустого состояния: сводка за период
//
// Перенесена скриптом из набора дизайн-системы, руками не правится. Цвета заменены на
// семантические классы: под ними лежат переменные `--illustration-*`, у которых в тёмной
// теме своя ступень серого. Без этого картинка светилась бы белым пятном на тёмном экране.

import type { SVGProps } from 'react';

export function IllustrationПериод(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 148 148' fill='none' {...props}>
      <rect className='fill-illustration-weak-100' width='148' height='148' rx='74' />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M74.1976 22.8406V36.8778C73.3242 36.9093 72.4665 36.98 71.6168 37.0824C55.825 38.9707 43.5818 52.4021 43.5818 68.7052C43.5818 68.9807 43.5818 69.2481 43.5897 69.5236H27.5148C27.5148 44.6046 47.0282 24.2491 71.6168 22.9115C72.4665 22.8642 73.3321 22.8406 74.1976 22.8406Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M120.88 69.5235H107.284C107.292 69.2559 107.292 68.9807 107.292 68.7052C107.292 68.0915 107.276 67.4777 107.237 66.8797C106.953 61.7732 105.458 56.9892 103.051 52.8112C102.523 51.8905 101.949 51.0093 101.335 50.1516L112.194 42.3935C112.807 43.251 113.397 44.1324 113.94 45.0295C116.671 49.4435 118.685 54.3455 119.81 59.5778C120.33 61.9464 120.668 64.3855 120.802 66.8796C120.857 67.7531 120.88 68.6345 120.88 69.5235Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M60.6085 52.8252L67.3137 59.5226'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M67.3108 52.8213L60.6134 59.5265'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M81.0795 52.8134L87.7847 59.5107'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M87.7815 52.8094L81.0841 59.5146'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M64.7975 66.413L82.1728 66.4029'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M116.836 42.958L113.94 45.0273L103.051 52.8092C102.523 51.8887 101.949 51.0073 101.335 50.1498C95.5521 42.0924 86.1101 36.8522 75.4406 36.8522C75.0235 36.8522 74.6065 36.86 74.1974 36.8758C73.324 36.9073 72.4663 36.978 71.6166 37.0804V19.6913C90.2489 19.6913 106.757 28.8738 116.836 42.958Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-strong-400 stroke-illustration-strong-400'
        d='M127.482 69.5238H107.292C107.347 67.8007 107.26 66.0617 107.024 64.2991C106.985 64.0317 106.946 63.7562 106.898 63.4888C106.804 62.8829 106.694 62.277 106.56 61.6948L119.81 59.5781L126.679 58.4845C127.27 62.1983 127.529 65.8885 127.482 69.5238Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M40.0858 95.7862C44.5036 95.7862 48.085 92.2049 48.085 87.787C48.085 83.3692 44.5036 79.7878 40.0858 79.7878C35.6679 79.7878 32.0865 83.3692 32.0865 87.787C32.0865 92.2049 35.6679 95.7862 40.0858 95.7862Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300'
        d='M40.0858 91.2602C42.004 91.2602 43.5589 89.7052 43.5589 87.787C43.5589 85.8689 42.004 84.3139 40.0858 84.3139C38.1676 84.3139 36.6127 85.8689 36.6127 87.787C36.6127 89.7052 38.1676 91.2602 40.0858 91.2602Z'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M73.9361 96.3435C78.354 96.3435 81.9353 92.7621 81.9353 88.3442C81.9353 83.9264 78.354 80.345 73.9361 80.345C69.5183 80.345 65.9369 83.9264 65.9369 88.3442C65.9369 92.7621 69.5183 96.3435 73.9361 96.3435Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-strong-400'
        d='M73.9361 91.8174C75.8543 91.8174 77.4093 90.2624 77.4093 88.3443C77.4093 86.4261 75.8543 84.8711 73.9361 84.8711C72.018 84.8711 70.463 86.4261 70.463 88.3443C70.463 90.2624 72.018 91.8174 73.9361 91.8174Z'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M107.787 96.3435C112.205 96.3435 115.786 92.7621 115.786 88.3442C115.786 83.9264 112.205 80.345 107.787 80.345C103.369 80.345 99.7875 83.9264 99.7875 88.3442C99.7875 92.7621 103.369 96.3435 107.787 96.3435Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200'
        d='M107.786 91.8174C109.705 91.8174 111.26 90.2624 111.26 88.3443C111.26 86.4261 109.705 84.8711 107.786 84.8711C105.868 84.8711 104.313 86.4261 104.313 88.3443C104.313 90.2624 105.868 91.8174 107.786 91.8174Z'
      />
      <path
        className='fill-illustration-soft-200'
        d='M85.4614 104.361H64.3448V109.984H85.4614V104.361Z'
      />
      <path
        className='fill-illustration-sub-300'
        d='M82.974 115.681H66.8324V121.304H82.974V115.681Z'
      />
      <path
        className='fill-illustration-sub-300'
        d='M116.087 115.681H99.9449V121.304H116.087V115.681Z'
      />
      <path
        className='fill-illustration-sub-300'
        d='M48.5968 115.682H32.4552V121.304H48.5968V115.682Z'
      />
      <path
        className='fill-illustration-soft-200'
        d='M118.574 104.361H97.4572V109.984H118.574V104.361Z'
      />
      <path
        className='fill-illustration-soft-200'
        d='M51.085 104.361H29.9684V109.984H51.085V104.361Z'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M11.3517 18.0847C11.3517 18.0847 16.0489 24.9049 22.8617 20.247C16.0488 24.905 20.6994 31.757 20.6994 31.757C20.6994 31.757 16.0022 24.9367 9.18925 29.5947C16.0022 24.9367 11.3517 18.0847 11.3517 18.0847Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M131.908 111.61C131.908 111.61 130.407 119.755 138.518 121.278C130.406 119.755 128.85 127.888 128.85 127.888C128.85 127.888 130.351 119.744 122.24 118.22C130.351 119.744 131.908 111.61 131.908 111.61Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
